import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["title", "aria-label"]

import { computed } from 'vue'
import type { StationStatusIcon } from './useStationRowStyle'

/**
 * Ícones de status das variantes `stack`/`row` do card (celular v2). Mesma lista, condições e
 * ordem do desktop (`statusIcons` do `useStationRowStyle`). Sem `v-tooltip`: no toque não há
 * hover e o tooltip pesa em ~280 cards por semana (spec §8.4, plano B); `title`/`aria-label`
 * mantêm o rótulo. O ramo `default` do `withIcon` NÃO usa este componente (desktop literal).
 *
 * v2.2: sempre numa linha só (sem quebra). `max` = quantos espaços de 16 px cabem; acima dele
 * mostra `max - 1` ícones e um "+N" no último espaço, com os rótulos escondidos no title/aria.
 * Com `max` o gap cai para 1 px (3 × 16 + 2 × 1 = 50 px cabe no iPhone SE). Sem `max`, mostra
 * todos com o gap de antes (comportamento anterior).
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'StationRowIcons',
  props: {
    icons: {},
    max: {}
  },
  setup(__props: any) {

const props = __props;



const overflows = computed(() => props.max !== undefined && props.icons.length > props.max)
const visibleIcons = computed(() =>
  overflows.value ? props.icons.slice(0, Math.max(0, (props.max ?? 0) - 1)) : props.icons
)
const hiddenIcons = computed(() => props.icons.slice(visibleIcons.value.length))
const hiddenLabels = computed(() => hiddenIcons.value.map((icon) => icon.label).join(', '))

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["station-row-icons flex flex-nowrap items-center", _ctx.max === undefined ? 'gap-0.5' : 'gap-px']),
    "data-testid": "station-row-icons"
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleIcons.value, (icon) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: icon.key
      }, [
        (icon.component)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(icon.component), {
              key: 0,
              class: "h-4 w-4 shrink-0",
              title: icon.label,
              "aria-label": icon.label,
              "data-testid": icon.testId ?? `station-row-icon-${icon.key}`
            }, null, 8, ["title", "aria-label", "data-testid"]))
          : (_openBlock(), _createBlock(_component_v_icon, {
              key: 1,
              icon: icon.path,
              color: icon.color,
              size: "16",
              class: "shrink-0",
              title: icon.label,
              "aria-label": icon.label,
              "data-testid": icon.testId ?? `station-row-icon-${icon.key}`
            }, null, 8, ["icon", "color", "title", "aria-label", "data-testid"]))
      ], 64))
    }), 128)),
    (hiddenIcons.value.length)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "inline-flex h-4 min-w-[16px] shrink-0 items-center justify-center rounded bg-black/10 px-0.5 text-[10px] font-bold leading-none text-gray-700",
          title: hiddenLabels.value,
          "aria-label": `Mais ${hiddenIcons.value.length}: ${hiddenLabels.value}`,
          "data-testid": "station-row-icons-more"
        }, "+" + _toDisplayString(hiddenIcons.value.length), 9, _hoisted_1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})